var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.57056 3.78284L21.4658 3.78284","stroke":"white","strokeWidth":"0.8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.2554 1.6449L21.3932 3.78277L19.2554 5.92064","stroke":"white","strokeWidth":"0.8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowRight.defaultProps = {"width":"24","height":"8","viewBox":"0 0 24 8","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
